<template v-slot="props">
  <ul v-if="inspectionResults && Object.keys(inspectionResults).length > 0" class="item" style="padding-top: 10px;">
    <li v-for="(value, key) in inspectionResults" v-if="value"><strong>{{ formatKey(key) }}</strong>: {{ value }}<br/></li>
  </ul>
</template>

<script>
import {formatTaskFieldKey} from '@/utilities/utils'

export default {
  props: ['data'],
  computed: {
    task() {
      return this.data
    },
    inspectionResults() {
      let inspectionResults = {}
      if (this.data && this.data.fieldValues) {
        for (const fieldValue in this.data.fieldValues) {
          if (fieldValue.includes('InspectionResult') || fieldValue.includes('inspectionResult')) {
            inspectionResults[fieldValue] = this.data.fieldValues[fieldValue]
          }
        }
      }
      return inspectionResults
    },
    taskTemplates() {
      return this.$store.get('tasks/templates/results')
    }
  },
  methods: {
    formatKey(fieldKey) {
      return formatTaskFieldKey(this.taskTemplates, this.task, fieldKey)
    }
  }
}
</script>
